/**
 * Construct and render image previews.
 *
 * @module preview.bookmark
 */

'use strict';

var app = require('mag-app');


/**
 * Render image/photo preview with given properties.
 *
 * @param {Object} page - working page
 * @param {string} url - resource uri
 * @param {Object} item - particular image data
 */

module.exports = function ( page, url, item ) {
    var random            = require('./random'),
        request           = require('./request'),
        div               = require('./div'),
        resolution        = screen.height,
        image             = new Image(),
        loadAttemptsCount = 0,
        baseUrls          = [
            'free.pagepeeker.com',
            'free2.pagepeeker.com',
            'free3.pagepeeker.com',
            'free4.pagepeeker.com'
        ],
        sizes             = {
            480: {
                thumb: 's',
                dummy: '/img/480/bookmark.placeholder.png'
            },
            576: {
                thumb: 's',
                dummy: '/img/576/bookmark.placeholder.png'
            },
            720: {
                thumb: 'm',
                dummy: '/img/720/bookmark.placeholder.png'
            },
            1080: {
                thumb: 'l',
                dummy: '/img/1080/bookmark.placeholder.png'
            }
        },
        imageContainer;

    image.onload = function () {
        var nodes = [
            imageContainer = div('imagePreviewContainer'),
            div('title theme-subhead-color', gettext('Name') + ':'),
            div(null, item.title),
            div('title theme-subhead-color', gettext('URL') + ':'),
            div('previewBookmarkUrl', item.url)
        ];

        page.textArea.$body.innerHTML = '';

        nodes.forEach(function ( node ) {
            page.textArea.$body.appendChild(node);
        });

        page.textArea.show();
        page.textArea.init();
        imageContainer.style.backgroundImage = 'url(' + image.src + ')';
    };

    image.onerror = function () {
        image.src = sizes[resolution].dummy;

        if ( loadAttemptsCount++ < app.config.bookmarkPreviewLoadAttemptsLimit ) {
            image.onload();
        }
    };

    if ( url[url.length - 1] === '/' ) {
        url = url.substring(0, url.length - 1);
    }

    (new Image()).src = 'http://free.pagepeeker.com/v2/thumbs.php?size=' + sizes[resolution].thumb + '&refresh=1&url=' + url;

    request('get', 'http://free.pagepeeker.com/v2/thumbs_ready.php?size=' + sizes[resolution].thumb + '&url=' + url, function ( data ) {
        image.src = data && data.IsReady ? 'http://' + baseUrls[random(0, 3)] + '/v2/thumbs.php?size=' + sizes[resolution].thumb + '&url=' + url : sizes[resolution].dummy;
    }, {charset: 'utf-8'}, 'json');
};
